import { createSlice } from "@reduxjs/toolkit"
import { SelectedAPIsInterface } from "../../utils/constants/Interfaces.constants"

const initialState: SelectedAPIsInterface = {
    cart: [],
    cartIDs: [],
    production: [],
    showSideModal: false,
    sideModalOption: 'cart',
    orderTabOption: 'uat'
}

const selectedAPIsSlice = createSlice({
    name: 'selectedAPIs',
    initialState: initialState,
    reducers: {
        setCart: (state,action) => {
            state.cart = action.payload
        },
        setProduction: (state,action) => {
            state.production = action.payload
        },
        setCartIDs: (state,action) => {
            state.cartIDs = action.payload
        },
        setShowSideModal: (state, action) => {
            state.showSideModal = action.payload
        },
        setSideModalOption: (state, action) => {
            state.sideModalOption = action.payload
        },
        setOrderTab: (state, action) => {
            state.orderTabOption = action.payload
        }
    }
})

export const { setCart, setProduction, setShowSideModal, setSideModalOption, setCartIDs, setOrderTab } = selectedAPIsSlice.actions
export default selectedAPIsSlice.reducer